import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import ComingSoon from "../feature-module/pages/comingSoon";
import Login from "../feature-module/auth/login/login";
import Error404 from "../feature-module/pages/error/error-404";
import Error500 from "../feature-module/pages/error/error-500";
import UnderMaintenance from "../feature-module/pages/underMaintenance";
import ForgetPassword from "../feature-module/auth/forgetPassword/forgetPassword";
import StudentGrid from "../components/Peoples/Student/student-grid";
import StudentForm from "../components/Peoples/Student/StudentFrom";
import StudentList from "../components/Peoples/Student/StudentList";
import StudentLibrary from "../components/Peoples/Student/student-details/studentLibrary";
import StudentDetails from "../components/Peoples/Student/student-details/studentDetails";
import StudentResult from "../components/Peoples/Student/student-details/studentResult";
import StudentTimeTable from "../components/Peoples/Student/student-details/studentTimeTable";
import Classes from "../feature-module/academic/classes/pages/ClassComponent";
import TeacherGrid from "../components/Peoples/Teacher/teacher-grid";
import TeacherForm from "../components/Peoples/Teacher/TeacherForm";
import TeacherList from "../components/Peoples/Teacher/TeacherList";
import TeacherDetails from "../components/Peoples/Teacher/teacher-details/teacherDetails";
import TeacherLibrary from "../components/Peoples/Teacher/teacher-details/teacherLibrary";
import PlanningManager from "../feature-module/academic/planning/WeeklyPlannerPage";
import ProtectedRoute from "./ProtectedRoute";
import TeacherDetailsLayout from "../components/Peoples/Teacher/teacher-details/TeacherDetailsLayout";
import TeacherRoutine from "../components/Peoples/Teacher/teacher-details/teacherRoutine";
import SchedulePage from "../feature-module/academic/absence/pages/DailySchedulePage";
import AbsencePage from "../feature-module/academic/absence/pages/AbsencesPage";
import MyAbsencesPage from "../feature-module/academic/absence/pages/MyAbsencesPage";
import TeacherTaskPage from "../feature-module/academic/class-task/pages/TeacherTaskPage";
import StudentTaskPage from "../feature-module/academic/class-task/pages/StudentTaskPage";
import MessagesPage from "../feature-module/academic/message/Pages/MessagesPage";
import ExamSessionsPage from "../feature-module/academic/mark/pages/PedagogyExamSessionsPage";
import TeacherExamSessionList from "../feature-module/academic/mark/pages/TeacherExamsessionsPage";
import ExamSessionClassPage from "../feature-module/academic/mark/pages/ExamSessionClassPage";
import StudentMarksPage from "../feature-module/academic/mark/pages/StudentMarksPage";
import SubjectList from "../components/Academic/subject/SubjectList";
import DashboardPage from "../feature-module/dashboard/pages/DashboardPage";
import GuardianList from "../components/Peoples/guardian/pages/GuardiansList";
import SetPasswordPage from "../feature-module/auth/SetPasswordPage";
import StudentRoutinePage from "../feature-module/academic/planning/StudentRoutinePage";
import AbsenceOverviewPage from "../feature-module/academic/absence/pages/AbsenceOverviewPage";
import StudentAlertsPage from "../feature-module/academic/absence/pages/StudentAlertsPage";
import StudentAbsenceDetailsPage from "../feature-module/academic/absence/pages/StudentAbsenceDetailsPage";
import FinanceDashboard from "../feature-module/finance/pages/FinanceDashboard";
import FinanceOverview from "../feature-module/finance/pages/FinanceOverview";
import FinanceFees from "../feature-module/finance/pages/FinanceFees";
import FeesTypes from "feature-module/settings/pages/feesTypes";
import FeeInvoice from "feature-module/finance/pages/FeeInvoice";
import ExpenseCategories from "feature-module/settings/pages/expenseCategories";
import Suppliers from "feature-module/settings/pages/suppliers";
import Expenses from "../feature-module/finance/pages/Expenses";
import MyFees from "feature-module/finance/pages/MyFees";
import { CertificateSettingsPage } from "feature-module/administration/instance-settings/pages/CertificateSettingsPage";
import CertificateView from "feature-module/document/pages/DocumentView";
import path from "path";
import VerifyDocumentView from "feature-module/document/pages/VerifyDocumentView";
import ResetPassword from "../feature-module/auth/resetPassword/resetPassword";
import Profile from "feature-module/academic/profile/pages/profile";
import UserManagement from "feature-module/settings/pages/userManagement";
import PlanificationSettings from "feature-module/settings/pages/PlanificationSettings";
import AbsenceSettings from "feature-module/settings/pages/AbsenceSettings";
import SubjectCoefficientPage from "feature-module/settings/pages/SubjectCoefficientsPage";
import AuditLogs from "feature-module/settings/pages/AuditLogs";
import InstancesPage from "feature-module/superAdmin/pages/InstancesPage";
import DashboardPageSuperAdmin from "feature-module/superAdmin/pages/DashboardPage";
import RolesSettings from "feature-module/settings/pages/RolesSettings";
import DetailClassPage from "feature-module/academic/classes/pages/DetailClassPage";
import StaffPage from "feature-module/hrm/pages/StaffPage";
import UserManagerForm from "feature-module/settings/components/UserManagerForm";
import LeavePage from "feature-module/hrm/pages/LeavePage";
import MyLeavePage from "feature-module/hrm/pages/MyLeavePage";
import MarkMatrix from "feature-module/academic/mark/pages/MarkMatrix";
import TeacherTasks from "components/Peoples/Teacher/teacher-details/teacherTasks";
import TeacherLeaves from "components/Peoples/Teacher/teacher-details/teacherLeaves";
import StudentDetailsLayout from "components/Peoples/Student/student-details/StudentDetailsLayout";
import StudentFeesTab from "components/Peoples/Student/student-details/StudentFeesTab";
import StudentDetailsTab from "components/Peoples/Student/student-details/StudentDetailsTab";
import StudentRoutineTab from "components/Peoples/Student/student-details/studentRoutineTab";
import StudentAbsencesTab from "components/Peoples/Student/student-details/studentAbsencesTab";
import StudentMarksTab from "components/Peoples/Student/student-details/studentMarksTab";
import StudentTaskTab from "components/Peoples/Student/student-details/studentTaskTab";
import TeacherClassesTab from "components/Peoples/Teacher/teacher-details/teacherClassesTab";
import RoutinePage from "feature-module/academic/planning/RoutinePage";
import PayrollPage from "feature-module/hrm/pages/PayrollPage";
import PayrollDetailPage from "feature-module/hrm/pages/PayrollDetailPage";
import MyPayrollPage from "feature-module/hrm/pages/MyPayrollPage";
import StaffFormPage from "feature-module/hrm/pages/StaffFormPage";
import SettingsPage from "feature-module/settings/pages/settingsPage";
import AuthorizedPickUpPersonPage from "feature-module/administration/authorized-pickup-persons/pages/AuthorizedPickUpPersonPage";
import StudentAuthorizedPickUpPersonTab from "components/Peoples/Student/student-details/StudentAuthorizedPickUpPersonTab";
import StudentExitPage from "feature-module/academic/student-exit/pages/StudentExitPage";
import StudentExitTab from "components/Peoples/Student/student-details/studentExitTab";
import MyStudentExitPage from "feature-module/academic/student-exit/pages/MyStudentExitPage";
import PriceSimulatorPage from "feature-module/superAdmin/pages/PriceSimulatorPage";
import CashBoxesPage from "feature-module/finance/pages/CashBoxesPage";
import CashboxTodayPage from "feature-module/finance/pages/CashboxTodayPage";
import CashboxTransactionsPage from "feature-module/finance/pages/CashboxTransactionsPage";
import TeacherMarkStudents from "feature-module/academic/mark/pages/TeacherMarkStudents";
import TeacherClassesPage from "feature-module/academic/classes/pages/TeacherClassesPage";
import TeacherStudentsPage from "components/Peoples/Student/pages/TeacherStudentsPage";
import UsersPage from "feature-module/superAdmin/pages/UsersPage";
import TeacherJournalsPage from "feature-module/academic/teacherJournal/pages/TeacherJournalsPage";
import TeacherJournalTeacherPage from "feature-module/academic/teacherJournal/pages/TeacherJournalTeacherPage";
import TeacherJournalFlipBookPage from "feature-module/academic/teacherJournal/pages/TeacherJournalFlipBookPage";
import MessagingSettings from "feature-module/settings/pages/MessagingSettings";

const routes = all_routes;

export const privateRoutes = [
  {
    path: routes.messages,
    element: (
      <ProtectedRoute
        action="read"
        subject="Message"
        element={<MessagesPage />}
      />
    ),
    route: Route,
  },
  // Peoples Module
  {
    path: routes.studentGrid,
    element: <StudentGrid />,
  },
  {
    path: routes.studentList,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Student"
        element={<StudentList />}
      />
    ),
    route: Route,
  },
  {
    path: routes.addStudent,
    element: (
      <ProtectedRoute
        action="create"
        subject="Student"
        element={<StudentForm />}
      />
    ),
    route: Route,
  },
  {
    path: routes.editStudent,
    element: (
      <ProtectedRoute
        action="update"
        subject="Student"
        element={<StudentForm />}
      />
    ),
    route: Route,
  },
  // {
  //   path: routes.studentLibrary,
  //   element: <StudentLibrary />,
  // },
  // {
  //   path: routes.studentDetail,
  //   element: (
  //     <ProtectedRoute
  //       action="getAll"
  //       subject="Fee"
  //       element={<StudentDetails />}
  //     />
  //   ),
  //   route: Route,
  // },
  // {
  //   path: routes.studentResult,
  //   element: <StudentResult />,
  // },
  // {
  //   path: routes.studentTimeTable,
  //   element: <StudentTimeTable />,
  // },
  {
    path: routes.subject,
    element: (
      <ProtectedRoute
        action="read"
        subject="Subject"
        element={<SubjectList />}
      />
    ),
    route: Route,
  },
  {
    path: routes.dashboard,
    element: (
      <ProtectedRoute
        action="read"
        subject="Dashboard"
        element={<DashboardPage />}
      />
    ),
    route: Route,
  },
  {
    path: routes.examSession,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="ExamSession"
        element={<ExamSessionsPage />}
      />
    ),
    route: Route,
  },
  {
    path: routes.markMatrix,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Mark"
        element={<MarkMatrix />}
      />
    ),
  },
  {
    path: routes.teacherExamSession,
    element: (
      <ProtectedRoute
        action="read"
        subject="ExamSession"
        element={<TeacherExamSessionList />}
      />
    ),
    route: Route,
  },
  {
    path: routes.ExamSessionClass,
    element: (
      <ProtectedRoute
        action="create"
        subject="Mark"
        element={<ExamSessionClassPage />}
      />
    ),
    route: Route,
  },
  {
    path: routes.ExamsClassSemester,
    element: (
      <ProtectedRoute
        action="create"
        subject="Mark"
        element={<TeacherMarkStudents />}
      />
    ),
    route: Route,
  },
  {
    path: routes.markMatrixTeacher,
    element: (
      <ProtectedRoute
        action="create"
        subject="Mark"
        element={<TeacherMarkStudents />}
      />
    ),
    route: Route,
  },

  {
    path: routes.StudentMarks,
    element: (
      <ProtectedRoute
        action="read"
        subject="Mark"
        element={<StudentMarksPage />}
      />
    ),
    route: Route,
  },
  {
    path: routes.attendanceDailySchedule,
    element: (
      <ProtectedRoute
        action="create"
        subject="Absence"
        element={<SchedulePage />}
      />
    ),
    route: Route,
  },
  {
    path: routes.absenceList,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Absence"
        element={<AbsencePage />}
      />
    ),
    route: Route,
  },
  {
    path: routes.absenceOverview,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Absence"
        element={<AbsenceOverviewPage />}
      />
    ),
    route: Route,
  },
  {
    path: routes.absenceAlerts,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Absence"
        element={<StudentAlertsPage />}
      />
    ),
    route: Route,
  },
  {
    path: routes.absenceStudentDetails,
    element: (
      <ProtectedRoute
        action="update"
        subject="Absence"
        element={<StudentAbsenceDetailsPage />}
      />
    ),
    route: Route,
  },
  {
    path: routes.absenceStudent,
    element: (
      <ProtectedRoute
        action="read"
        subject="Absence"
        element={<MyAbsencesPage />}
      />
    ),
    route: Route,
  },
  {
    path: routes.classes,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Class"
        element={<Classes />}
      />
    ),
  },
  {
    path: routes.detailClass,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Class"
        element={<DetailClassPage />}
      />
    ),
  },
  {
    path: routes.classTask,
    element: (
      <ProtectedRoute
        action="create"
        subject="Task"
        element={<TeacherTaskPage />}
      />
    ),
  },
  {
    path: routes.myTasks,
    element: (
      <ProtectedRoute
        action="read"
        subject="Task"
        element={<StudentTaskPage />}
      />
    ),
  },
  {
    path: routes.teacherGrid,
    element: <TeacherGrid />,
  },
  {
    path: routes.guardiansList,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Guardian"
        element={<GuardianList />}
      />
    ),
    route: Route,
  },
  {
    path: routes.teacherList,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Teacher"
        element={<TeacherList />}
      />
    ),
    route: Route,
  },
  {
    path: routes.addTeacher,
    element: (
      <ProtectedRoute
        action="create"
        subject="Teacher"
        element={<TeacherForm />}
      />
    ),
  },
  {
    path: routes.editTeacher,
    element: (
      <ProtectedRoute
        action="update"
        subject="Teacher"
        element={<TeacherForm />}
      />
    ),
  },
  {
    path: routes.teacherDetails,
    element: <TeacherDetailsLayout />,
    children: [
      {
        path: "details",
        element: <ProtectedRoute action="getAll" subject="Planner" element={<TeacherDetails />} />,
      },
      {
        path: "routine",
        element: <ProtectedRoute action="getAll" subject="Teacher" element={<TeacherRoutine />} />,
      },
      {
        path: "tasks",
        element: <ProtectedRoute action="getAll" subject="Task" element={<TeacherTasks />} />,
      },
      {
        path: "leaves",
        element: <ProtectedRoute action="getAll" subject="Leave" element={<TeacherLeaves />} />,
      },
      {
        path: "classes",
        element: <ProtectedRoute action="getAll" subject="Class" element={<TeacherClassesTab />} />,
      },
    ],
  },
  {
    path: routes.studentDetails,
    element: <StudentDetailsLayout />,
    children: [
      {
        path: "details",
        element: <ProtectedRoute action="getAll" subject="Student" element={<StudentDetailsTab />} />,
      },
      {
        path: "fees",
        element: <ProtectedRoute action="getAll" subject="Fee" element={<StudentFeesTab />} />,
      },
      {
        path: "routine",
        element: <ProtectedRoute action="getAll" subject="Planner" element={<StudentRoutineTab />} />,
      },
      {
        path: "absences",
        element: <ProtectedRoute action="getAll" subject="Absence" element={<StudentAbsencesTab />} />,
      },
      {
        path: "marks",
        element: <ProtectedRoute action="getAll" subject="Mark" element={<StudentMarksTab />} />,
      },
      {
        path: "tasks",
        element: <ProtectedRoute action="getAll" subject="Task" element={<StudentTaskTab />} />,
      },
      {
        path: 'authorized-pick-up-person',
        element: <ProtectedRoute action="getAll" subject="AuthorizedPickUpPerson" element={<StudentAuthorizedPickUpPersonTab />} />,
      },
      {
        path: 'student-exit',
        element: <ProtectedRoute action="getAll" subject="StudentExit" element={<StudentExitTab />} />,
      },
    ],
  },
  {
    path: routes.teacherLibrary,
    element: <TeacherLibrary />,
  },
  {
    path: routes.planning,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Planner"
        element={<PlanningManager />}
      />
    ),
  },
  {
    path: routes.studentRoutine,
    element: (
      <ProtectedRoute
        action="read"
        subject="Routine"
        element={<RoutinePage />}
      />
    ),
  },

  {
    path: routes.myDocuments,
    element: (
      <ProtectedRoute
        action="read"
        subject="Document"
        element={<CertificateView />}
      />
    ),
  },
  {
    path: routes.financeDashboard,
    element: (
      <ProtectedRoute
        permissions={[
          { action: "getAll", subject: "Expense" },
          { action: "getAll", subject: "Fee" },
        ]}
        element={<FinanceDashboard />}
      />
    ),
  },
  {
    path: routes.financeOverview,
    element: (
      <ProtectedRoute
        permissions={[
          { action: "getAll", subject: "Expense" },
          { action: "getAll", subject: "Fee" },
        ]}
        element={<FinanceOverview />}
      />
    ),
  },
  {
    path: routes.financeFees,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Fee"
        element={<FinanceFees />}
      />
    ),
  },
  {
    path: routes.expenses,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Expense"
        element={<Expenses />}
      />
    ),
  },
  {
    path: routes.cashbox.list,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="CashBox"
        element={<CashBoxesPage />}
      />
    ),
  },
  {
    path: routes.cashbox.transactionHistory,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="CashBox"
        element={<CashboxTransactionsPage />}
      />
    ),
  },
  {
    path: routes.cashbox.today,
    element: (
      <ProtectedRoute
        permissions={[
          { action: "getAll", subject: "Expense" },
          { action: "getAll", subject: "Fee" },
        ]}
        element={<CashboxTodayPage />}
      />
    ),
  },
  {
    path: routes.feesTypes,
    element: (
      <ProtectedRoute
        action="update"
        subject="SettingsInstance"
        element={<FeesTypes />}
      />
    ),
  },
  {
    path: routes.expenseCategories,
    element: (
      <ProtectedRoute
        action="update"
        subject="SettingsInstance"
        element={<ExpenseCategories />}
      />
    ),
  },
  {
    path: routes.userManagement,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="UserManagement"
        element={<UserManagement />}
      />
    ),
  },
  {
    path: routes.UserManagementCreate,
    element: (
      <ProtectedRoute
        action="create"
        subject="UserManagement"
        element={<UserManagerForm />}
      />
    ),
  },
  {
    path: routes.UserManagementEdit,
    element: (
      <ProtectedRoute
        action="update"
        subject="UserManagement"
        element={<UserManagerForm />}
      />
    ),
  },
  {
    path: routes.subjectCoefficients,
    element: (
      <ProtectedRoute
        action="update"
        subject="SettingsInstance"
        element={<SubjectCoefficientPage />}
      />
    ),
  },
  {
    path: routes.auditLogs,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="AuditLog"
        element={<AuditLogs />}
      />
    ),
  },
  {
    path: routes.instanceSettings,
    element: (
      <ProtectedRoute
        action="update"
        subject="SettingsInstance"
        element={<CertificateSettingsPage />}
      />
    ),
  }, {
    path: routes.planificationSettings,
    element: (
      <ProtectedRoute
        action="update"
        subject="SettingsInstance"
        element={<PlanificationSettings />}
      />
    ),
  },
  {
    path: routes.absenceSettings,
    element: (
      <ProtectedRoute
        action="update"
        subject="SettingsInstance"
        element={<AbsenceSettings />}
      />
    ),
  },
  {
    path: routes.suppliers,
    element: (
      <ProtectedRoute
        action="update"
        subject="SettingsInstance"
        element={<Suppliers />}
      />
    ),
  },
  {
    path: routes.myfees,
    element: (
      <ProtectedRoute
        action="read"
        subject="StudentFee"
        element={<MyFees />}
      />
    ),
  },
  {
    path: routes.rolesPermissions,
    element: (
      <ProtectedRoute
        action="update"
        subject="SettingsInstance"
        element={<RolesSettings />}
      />
    ),
  },
  {
    path: routes.showFee,
    element: (
      <ProtectedRoute
        permissions={[{ action: "read", subject: "StudentFee" }, { action: "getAll", subject: "Fee" }]}
        element={<FeeInvoice />}
      />
    ),
  },
  {
    path: routes.profile,
    element: <Profile />,
  },
  {
    path: routes.staff,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Staff"
        element={<StaffPage />}
      />
    ),
  },
  {
    path: routes.staffCreate,
    element: (
      <ProtectedRoute
        action="create"
        subject="Staff"
        element={<StaffFormPage />}
      />
    ),
  },
  {
    path: routes.staffEdit,
    element: (
      <ProtectedRoute
        action="update"
        subject="Staff"
        element={<StaffFormPage />}
      />
    ),
  },
  {
    path: routes.leave,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Leave"
        element={<LeavePage />}
      />
    ),
  },
  {
    path: routes.payroll,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="Payroll"
        element={<PayrollPage />}
      />
    ),
  },
  {
    path: routes.myPayroll,
    element: (
      <ProtectedRoute
        action="read"
        subject="Payroll"
        element={<MyPayrollPage />}
      />
    ),
  },
  {
    path: routes.detailPayroll,
    element: (
      <ProtectedRoute
        permissions={[{ action: "read", subject: "Payroll" }, { action: "getAll", subject: "Payroll" }]}
        element={<PayrollDetailPage />}
      />
    ),
  },
  {
    path: routes.myLeave,
    element: (
      <ProtectedRoute
        action="read"
        subject="Leave"
        element={<MyLeavePage />}
      />
    ),
  },
  {
    path: routes.allSettings,
    element: (
      <ProtectedRoute
        action="update"
        subject="SettingsInstance"
        element={<SettingsPage />}
      />
    ),
  },
  {
    path: routes.authorizedPickUpPerson,
    element: (
      <ProtectedRoute
        action="read"
        subject="AuthorizedPickUpPerson"
        element={<AuthorizedPickUpPersonPage />}
      />
    ),
  },
  {
    path: routes.studentExit,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="StudentExit"
        element={<StudentExitPage />}
      />
    ),
  },
  {
    path: routes.myStudentExit,
    element: (
      <ProtectedRoute
        action="read"
        subject="StudentExit"
        element={<MyStudentExitPage />}
      />
    ),
  },
  {
    path: routes.myClasses,
    element: (
      <ProtectedRoute
        action="read"
        subject="Class"
        element={<TeacherClassesPage />}
      />
    ),
  },
  {
    path: routes.myStudent,
    element: (
      <ProtectedRoute
        action="read"
        subject="Student"
        element={<TeacherStudentsPage />}
      />
    ),
  },
  {
    path: routes.teacherJournal,
    element: (
      <ProtectedRoute
        action="getAll"
        subject="TeacherJournal"
        element={<TeacherJournalsPage />}
      />
    ),
  },
  {
    path: routes.myTeacherJournal,
    element: (
      <ProtectedRoute
        action="read"
        subject="TeacherJournal"
        element={<TeacherJournalFlipBookPage />}
      />
    ),
  },
  {
    path: routes.messagingSettings,
    element: (
      <ProtectedRoute
        action="update"
        subject="SettingsInstance"
        element={<MessagingSettings />}
      />
    ),
  },

  // super admin
  {
    path: routes.superAdmin.instance,
    element: (
      <ProtectedRoute
        action="isSuperAdmin"
        subject="SettingsInstance"
        element={<InstancesPage />}
      />
    ),
  },
  {
    path: routes.superAdmin.dashboard,
    element: (
      <ProtectedRoute
        action="isSuperAdmin"
        subject="Dashboard"
        element={<DashboardPageSuperAdmin />}
      />
    ),
  },
  {
    path: routes.superAdmin.priceSimulator,
    element: (
      <ProtectedRoute
        action="isSuperAdmin"
        subject="Dashboard"
        element={<PriceSimulatorPage />}
      />
    ),
  },
  {
    path: routes.superAdmin.users,
    element: (
      <ProtectedRoute
        action="isSuperAdmin"
        subject="Dashboard"
        element={<UsersPage />}
      />
    ),
  },

];

export const publicRoutes = [
  {
    path: routes.comingSoon,
    element: <ComingSoon />,
    route: Route,
  },
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgetPassword />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.passwordSetup,
    element: <SetPasswordPage />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
  },
  {
    path: routes.verifyDocument,
    element: <VerifyDocumentView />,
  },


];
